import { configureTracking } from '@zapier/toolbox-tracking';

const initializeTracking = config => {
  const { commitHash } = config;

  configureTracking({
    // This service name must remain 'ssr', even though multiple SSR services
    // exist, because our data pipeline is hard-coded to query for tracking
    // data using this service name.
    //
    // Slack discussion: https://zapier.slack.com/archives/C028W5V2A/p1586178932263500?thread_ts=1585947368.249300&cid=C028W5V2A
    service: 'ssr',
    release: commitHash || '<unknown>',
  });
};

export default initializeTracking;
